<script>
import SinglelineAssort from './SinglelineAssort'
import TwocolumnRow from './TwocolumnRow'
import ThreecolumnRow from './ThreecolumnRow'
import LineColumn from './LineColumn'
import MarginCarousel from './MarginCarousel'
import Carousel from './Carousel'
import MorelineAssort from './MorelineAssort'
import PromptCenter from './PromptCenter'
import DropPromptCenter from './DropPromptCenter'
import Author from './Author'
import SlideLine from './SlideLine'
import AdLine from './AdLine'
import AdContainer from './AdContainer'

export default {
    render: function (createElement) {
        var element = null
        var obj = {
            props: {list: this.list}
        }
        var other = {
            dataTitle: this.dataTitle,
            dataId: this.dataId,
            clickMore: this.clickMore,
            isShowTitle: this.isShowTitle,
            hasMore: this.hasMore
        }
        switch (this.template) {
            case 'ad-line':
                element = AdLine
                break;
            case 'ad-container':
                element = AdContainer
                break;
            case 'margin-carousel':
                element = MarginCarousel
                break;
            case 'singleline-assort':
                element = SinglelineAssort
                break;
            case 'moreline-assort':
                element = MorelineAssort
                break;
            case 'popup-center':
                element = PromptCenter
                break;
            case 'drop-popup-center':
                element = DropPromptCenter
                break;
            case 'threecolumn-row':
                element = ThreecolumnRow
                Object.assign(obj.props, other)
                obj.on = {
                    clickMore: this.clickMore
                }
                break;
            case 'line-column':
                element = LineColumn
                Object.assign(obj.props, other)
                obj.on = {
                    clickMore: this.clickMore
                }
                break;
            case 'carousel':
                element = Carousel
                Object.assign(obj.props, other)
                obj.on = {
                    clickMore: this.clickMore
                }
                break;
            case 'author':
                element = Author
                Object.assign(obj.props, other)
                obj.on = {
                    clickMore: this.clickMore
                }
                break;
            case 'slide-line':
                element = SlideLine
                Object.assign(obj.props, other)
                obj.on = {
                    clickMore: this.clickMore
                }
                break;
            default:
                element = TwocolumnRow
                Object.assign(obj.props, other)
                obj.on = {
                    clickMore: this.clickMore
                }
                break;
        }
        return createElement(
            element,
            obj
        )
    },
    props: {
        template: String,
        list: Array,
        dataTitle: String,
        dataId: Number,
        clickMore: {
            type: Function,
            default: ()=>{
                return ()=>{}
            }
        },
        isShowTitle: Boolean,
        hasMore: Number
    }
}
</script>